import image from "assets/img/homepage/ecommerce-3562005_1920.jpg";
import { vivoFontGrayColor } from "assets/jss/vivoleo-react-kit";
import imagesStyles from "assets/jss/vivoleo-react-kit/imagesStyles.js";
import {
  container,
  sectionSpace,
  space30,
  space50,
  vivoblueColor,
} from "assets/jss/vivoleo-react-kit.js";
const RecordSearchScreenStyle = {
  ...imagesStyles,
  sectionSpace,
  space30,
  space50,
  topSpace: {
    marginTop: "10px",
  },
  textCenter: {
    textAlign: "center",
    fontWeight: "600",
  },
  ourworkCard: {
    maxWidth: "100%",
    padding: "0.8rem 1.2rem",
    "@media (min-width: 320px)": {
      height: "320px",
    },
    "@media (min-width: 576px)": {
      height: "320px",
    },
    "@media (min-width: 768px)": {
      height: "350px",
    },
    "@media (min-width: 960px)": {
      height: "300px",
    },
    "@media (min-width: 1024px)": {
      height: "300px",
    },
    "@media (min-width: 1280px)": {
      height: "300px",
    },
    "@media (min-width: 1920px)": {
      height: "300px",
    },
    justifyContent: "space-between",
    flexDirection: "column",
    display: "flex",
  },
  ourworkCard2: {
    maxWidth: "100%",
    padding: "0",
    maigin: "0",
    "@media (max-width: 575px)": {
      height: "200px",
    },
    "@media (min-width: 576px)": {
      height: "200px",
    },
    "@media (min-width: 768px)": {
      height: "220px",
    },
    "@media (min-width: 960px)": {
      height: "200px",
    },
    "@media (min-width: 1024px)": {
      height: "200px",
    },
    "@media (min-width: 1280px)": {
      height: "200px",
    },
    "@media (min-width: 1920px)": {
      height: "200px",
    },
    justifyContent: "space-between",
    flexDirection: "column",
    display: "flex",
  },
  stickBottom: {
    justifyContent: "center",
    display: "flex",
  },
  btnStickBottom: {
    marginBottom: "10px",
  },
  cardActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "16px",
  },
};

export default RecordSearchScreenStyle;
